var React = require('react');

function ChatIconOutline (props) {
    return React.createElement("svg",props,React.createElement("defs",null,React.createElement("clipPath",{"id":"cross"},React.createElement("path",{"d":"M57.978 52.4092C57.432 51.8681 57.443 51.0161 57.8801 50.3854C60.8983 46.0309 62.6646 40.7582 62.6646 35.0769C62.6646 20.1228 50.4275 8 35.3323 8C20.2371 8 8 20.1228 8 35.0769C8 46.4785 15 55.5 25.0827 60.0385C30.1205 62.3061 34.5 63 41.3112 63C48.9408 63 56.1605 61.2614 62.5886 58.1623C64 57.4818 65 56.3325 62.3281 55.1616C61.7084 54.89 61.106 54.5869 60.5228 54.2544C59.5796 53.7708 58.7218 53.1464 57.978 52.4092Z","fill":"#ffffff"}))));
}

ChatIconOutline.defaultProps = {"height":"73","width":"73"};

module.exports = ChatIconOutline;

ChatIconOutline.default = ChatIconOutline;
